if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";

function init() {
  // initCursor();
  initNav();
}

window.addEventListener("load", function () {
  init();
});
